// extracted by mini-css-extract-plugin
export default {"header":"header--mGKcU","left":"left--oYEWH","icon":"icon--uCAwH","title":"title--Zw4GQ","right":"right--oiQ1H","btn":"btn--QRLqj","right1":"right1--q0AEx"};